import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ClipboardCheck, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function AssessmentPrompt() {
  const navigate = useNavigate();

  return (
    <Card className="bg-gradient-to-r from-slate-800/50 to-slate-900/50 border-slate-700">
      <div className="p-6">
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <h2 className="text-xl font-semibold">
              Complete Your Career Assessment
            </h2>
            <p className="text-slate-400">
              Take a quick assessment to get personalized career recommendations and unlock your learning path.
            </p>
            <Button 
              onClick={() => navigate('/assessment')}
              className="mt-4"
            >
              Start Assessment
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
          <ClipboardCheck className="w-12 h-12 text-primary-500" />
        </div>
      </div>
    </Card>
  );
}